import { Layout, Fit, Alignment, UseRiveParameters } from '@rive-app/react-canvas';

const riveConfig: UseRiveParameters = {
    src: `/animations/loading_dots.riv`,
    layout: new Layout({
        fit: Fit.FitWidth,
        alignment: Alignment.Center
    }),
    stateMachines: 'State Machine 1',
    autoplay: true
};
export default riveConfig;
